import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CTASection() {
  const navigate = useNavigate();
  return (
    <section className="bg-black pb-24 sm:pb-28">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <Reveal>
          <div className="gold-glow relative overflow-hidden rounded-3xl border border-brand/25 bg-neutral-950 px-8 py-16 text-center sm:px-16 sm:py-20">
            <div className="ts-grid-bg pointer-events-none absolute inset-0 opacity-40" />
            <div className="pointer-events-none absolute -right-20 -top-20 h-72 w-72 rounded-full bg-brand/20 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-brand/10 blur-3xl" />
            <div className="relative mx-auto max-w-2xl">
              <h2 className="font-display text-3xl font-black leading-[1.05] tracking-tight text-white sm:text-5xl">
                Let's collaborate, build, and{" "}
                <span className="text-gold-gradient">grow together.</span>
              </h2>
              <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-neutral-400">
                Reach out for collaborations, projects and business inquiries —
                we'd love to hear what you're working on.
              </p>
              <button
                onClick={() => navigate("/contact")}
                data-testid="cta-contact-button"
                className="group mt-9 inline-flex items-center gap-2 rounded-full bg-brand px-8 py-4 text-sm font-semibold text-black shadow-[0_4px_14px_0_rgb(212,175,55,0.39)] transition-transform duration-200 hover:-translate-y-0.5"
              >
                Start a conversation
                <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
